export const FETCH_PAYMENT = 'FETCH_PAYMENT';
export const CREATE_PAYMENT = 'CREATE_PAYMENT';
